module.exports = __webpack_public_path__ + "static/img/section_03_guitar_match_kv.1d66425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_03_guitar_match_kv.png
// module id = o8ts
// module chunks = 13